export default __webpack_public_path__ + "static/b_helles_01-dd66213cfc690aadfd99a7f1788749bd.png";